import { createApp } from "vue";
import "@fontsource/big-shoulders-display/700";
import "@fontsource/big-shoulders-display/900";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "./styles.css";
import App from "./App.vue";
import { router } from "./router";

createApp(App).use(router).mount("#app");
